import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';

export const createRotatedRouteIcon = (bearing = 0) => {
  return L.divIcon({
    className: 'route-marker-icon-container',
    html: `<div class="route-marker-rotator" style="transform: rotate(${bearing}deg); width: 25px; height: 41px; transform-origin: 12px 41px;">
                 <img src="${icon}" style="width: 25px; height: 41px; display: block;" alt="Marker" />
               </div>`,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    tooltipAnchor: [16, -28],
    popupAnchor: [1, -34],
  });
};
